// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"Banner_bannerContainer__2bYuS","textContainer":"Banner_textContainer__2hV9o","text":"Banner_text__vxrZM","button":"Banner_button__2x5UV"};